/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from "react";
import { config } from "../Constants";

import "../mgm/css/dropdown-select.css";
import "../mgm/css/registermgm.css";
import "../mgm/css/select.css";
import "../mgm/js/dropdown-select";
import cover from "../mgm/images/im-cover.jpg";
import coverM from "../mgm/images/im-cover-mob.jpg";
import logo from "../mgm/images/logo_pf.png";
import textfgf from "../mgm/images/MGM_Mobile.png";

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

export default class RegisterFGF extends Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(this.props.location.search);

    this.state = {
      project_home: [],
      gen_code: params.get("code") ? params.get("code") : "",
      refcode: params.get("refcode") ? params.get("refcode") : "",
      member_id: params.get("member_id") ? params.get("member_id") : "",
      add_name: "",
      add_phone: "",
      add_email: "",
      add_project: "",
      registerIsOpen: false,
      successIsOpen: false,
      errorIsOpen: false,
      isOpen: false,
      accepted_policy: false,
      selectedOption:{ value: "", display: "โครงการที่สนใจ" },
      options: [],
      url_policy:"https://www.pf.co.th/th/privacy-policy",
      url_notice:"https://www.pf.co.th/th/privacy-notice"
      
    };

    this.clearData = this.clearData.bind(this);
    this.submitRegister = this.submitRegister.bind(this);
    this.closeRegister = this.closeRegister.bind(this);
    this.openRegister = this.openRegister.bind(this);
    this.change = this.change.bind(this);
    this.closeSuccess = this.closeSuccess.bind(this);
    this.openSuccess = this.openSuccess.bind(this);
    this.project_home = this.project_home.bind(this);

    this.closeError = this.closeError.bind(this);
    this.openError = this.openError.bind(this);

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.project_home = this.project_home.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    // this.project_home();
  }
  
  componentDidMount() {
    // call project_home function to fetch options from API
    this.project_home();
  }

  toggleDropdown() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  handleOptionClick(option) {
    console.log(option)
    this.setState({ selectedOption: option, isOpen: false, add_project: option.value });
  }


  project_home() {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
  
      fetch(config.url.API_URL + "/fgfprojecthome/", requestOptions)
        .then(res => res.json())
        .then((response) => {
          const project_data = response.data.data
          var FromApi = project_data.map((data) => {
            return { value: data._id, display: data.name_th };
          });
  
          // set options to state
          this.setState({
            options: this.state.options.concat(
              FromApi
            ),
            // selectedOption: FromApi[0]
          });
        }).catch(error => {
          console.log(error)
        });
    } catch (error) {
      console.log(error)
    }
  }

  clearData(e) {
    this.setState({
      add_name: "",
      add_phone: "",
      add_email: "",
      add_project: "",
      member_id: "",
      gen_code: "",
    });
  }

  submitRegister(e) {
    try {
      if(this.state.accepted_policy === false){
        this.setState({
          registerIsOpen: false,
          error:'กรุณายอมรับนโยบายความเป็นส่วนตัว',
          errorIsOpen: true,
        })
        return
      }
  
      const requestOptions = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: this.state.add_name,
          phone: this.state.add_phone,
          email: this.state.add_email,
          project_home_id: this.state.add_project,
          gen_code: this.state.gen_code,
          member_id: this.state.member_id,
          refcode: this.state.refcode
        }),
      };
  
      fetch(config.url.API_URL + "/registermgm", requestOptions)
        .then((res) => res.json())
        .then(async(data) => {
          if (data.status === "Error") {
            this.setState({
              registerIsOpen: false,
              error: data.message,
              errorIsOpen: true,
            });
            await this.clearData();
  
          } else {
            this.setState({
              add_name: "",
              add_phone: "",
              add_email: "",
              add_project: "",
              registerIsOpen: false,
              successIsOpen: true,
            });
            await this.clearData();
  
            setTimeout(() => {
              window.location.replace("https://www.pf.co.th/");
            }, 5000); 
          }
        }).catch(error => {
          console.log(error)
          //window.location.reload(); // Reload the page
        });
    } catch (error) {
      console.log(error)
      //window.location.reload(); // Reload the page
    }
  }

  openRegister(e) {
    if (this.state.gen_code === "") {
      alert("ไม่พบข้อมูล MGM Code");
      return;
    }

    if (this.state.member_id === "") {
      alert("ไม่พบข้อมูล Member ID");
      return;
    }

    if (this.state.add_name === "") {
      alert("ไม่พบข้อมูลชื่อ-นามสกุล");
      return;
    }

    if (this.state.add_email === "") {
      alert("ไม่พบข้อมูลอีเมล์");
      return;
    }

    if (this.state.add_phone === "") {
      alert("ไม่พบข้อมูลเบอร์โทรศัพท์");
      return;
    }

    if (this.state.add_project === "") {
      alert("ไม่พบข้อมูลโครงการบ้าน");
      return;
    }

    this.setState({
      registerIsOpen: true,
    });
  }

  closeRegister(e) {
    document.getElementById("add_name").value = "";
    document.getElementById("add_phone").value = "";
    document.getElementById("add_email").value = "";
    // document.getElementById("add_project").value = "";
    this.setState({
      registerIsOpen: false,
      add_name: "",
      add_phone: "",
      add_email: "",
      add_project: "",
      selectedOption:{ value: "", display: "โครงการที่สนใจ" },
    });
  }

  handleCheckboxChange(){
    this.setState(prevState => ({
      accepted_policy: !prevState.accepted_policy
    }));
  };

  change(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  closeSuccess(e) {
    this.setState({
      successIsOpen: false,
    });
  }

  openSuccess(e) {
    this.setState({
      successIsOpen: true,
    });
  }

  closeError(e) {
    this.setState({
      errorIsOpen: false,
      error:''
    });
  }

  openError(e) {
    this.setState({
      errorIsOpen: true,
    });
  }
  render() {
    const { isOpen, selectedOption, options } = this.state;
    return (
      <div className="container-fluid p-0 fgf-con">
        <div className="content">
          <div className="grid-content01">
            <div className="ms-col-1">
              <img className="im-cover d-desktop" src={cover} alt="" />
              <img className="im-cover d-mobile" src={coverM} alt="" />
            </div>
            <div className="ms-col-2">
              <div className="heigth100">
                <div className="box-regis center01 mgt-3-mob">
                  <div className="mga d-grid">
                    <div className="row">
                      <img className="logo-pf" src={logo} alt="" />
                    </div>
                    <div className="row mgt-4">
                      <img className="im-fgf" src={textfgf} alt="" />
                    </div>
                    <div className="row d-flex justify-center mgt-3">
                      <font className="txt-cont01 colorBlue01 txt-center-mob">
                        คุณได้รับการแนะนำเพื่อน โครงการ Property Perfect
                      </font>
                    </div>
                    <div className="row d-flex justify-center mgt-3">
                      <div className="box-code">
                        <font className="txt-cont01 colorWhite">
                          รหัสแนะนำ {this.state.refcode.toUpperCase()}
                        </font>
                      </div>
                    </div>
                    <div className="row d-flex justify-center mgt-3">
                      <font className="txt-cont01 colorBlue01 txt-center-mob">
                        ถ้าหากสนใจเข้าชมโครงการ กรุณาลงทะเบียนเพื่อเยี่ยมชมโครงการ
                      </font>
                    </div>
                    <div className="mgt-3">
                      <input
                        className="inp-from txt-cont01 colorBlue01"
                        type="text"
                        placeholder="ชื่อ"
                        name="add_name"
                        id="add_name"
                        onChange={this.change}
                      />
                    </div>
                    <div className="grid-content mgt-3">
                      <div className="ms-col-1 mr-md-3 mr-sm-0">
                        <input
                          className="inp-from txt-cont01 colorBlue01"
                          type="text"
                          placeholder="เบอร์โทรศัพท์"
                          name="add_phone"
                          id="add_phone"
                          maxLength={10}
                          onKeyPress={(event) => {
                            const keyCode = event.which ? event.which : event.keyCode;
                            const keyValue = String.fromCharCode(keyCode);
                            if (!/^\d+$/.test(keyValue)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={this.change}
                        />
                      </div>
                      <div className="ms-col-2 mgt-mob">
                        <input
                          className="inp-from txt-cont01 colorBlue01"
                          type="text"
                          placeholder="อีเมล"
                          name="add_email"
                          id="add_email"
                          onChange={this.change}
                        />
                      </div>
                    </div>
                    <div className="mgt-3">
                      <div className={`prettydrop__wrapper ${isOpen ? 'prettydrop__wrapper--open' : ''}`}>
                        <div className="prettydrop__trigger" onClick={this.toggleDropdown}>
                        {selectedOption ? selectedOption.display : "เลือกโครงการ"}
                          <i className="fa fa-caret-down" aria-hidden="true"></i>
                        </div>
                        <ul className="prettydrop__dropdown pd-drp">
                          {options.map((option) => (
                            <div>
                              <li
                                key={option.value}
                                className={`${option.value === selectedOption.value ? 'active' : ''}`}
                                onClick={() => this.handleOptionClick(option)}
                              >
                                {option.display}
                              </li>
                              <hr/>
                            </div>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  
                  <div className="mr-md-3 mr-sm-0 ml-md-3 ml-sm-0 mgt-3 colorBlue01 privacy-policy-checkbox my-2">
                      <label className="checkbox-label">
                        <input
                          className="check-input"
                          type="checkbox"
                          checked={this.state.accepted_policy}
                          onChange={this.handleCheckboxChange}
                        />
                        <span className="label-text ml-2">ข้าพเจ้าตกลงรับข่าวสาร ข้อเสนอโปรโมชั่น ข้อมูลส่งเสริมการขายและการตลาด ผ่านช่องทางและสื่อต่างๆ ที่เกี่ยวข้องกับสินค้า และบริการของบมจ.พร็อพเพอร์ตี้ เพอร์เฟค และบริษัทในเครือ เจ้าหน้าที่แต่ละโครงการจะติดต่อกลับเพื่อให้ข้อมูล พร้อมสิทธิพิเศษเฉพาะผู้ลงทะเบียน  
                            <br/>
                          <a className="pr-1 fgflink" href={this.state.url_policy} target="_blank" rel="noopener noreferrer">นโยบายความเป็นส่วนตัว</a>
                          <a className="pl-1 fgflink" href={this.state.url_notice} target="_blank" rel="noopener noreferrer">ประกาศนโยบายความเป็นส่วนตัว</a>
                        </span>
                      </label>
                  </div>
                    <div className="fgf-btn text-center pb-3">
                    <button
                      className="btn-confirm colorWhite"
                      onClick={this.openRegister}
                    >
                      ยืนยัน
                    </button>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.registerIsOpen}
          onHide={this.closeRegister}
          size="s"
        >
          <ModalHeader>
            <ModalTitle>แจ้งเตือน</ModalTitle>
          </ModalHeader>
          <ModalBody>คุณต้องการยืนยันการลงทะเบียนครั้งนี้ใช่หรือไม่</ModalBody>
          <ModalFooter>
            <button className="btn btn-danger" onClick={this.closeRegister}>
              ยกเลิก
            </button>
            &nbsp;&nbsp;
            <button className="btn btn-success" onClick={this.submitRegister}>
              ยืนยัน
            </button>
          </ModalFooter>
        </Modal>

        <Modal show={this.state.errorIsOpen} onHide={this.closeError} size="s">
          <ModalHeader className="btn-danger">
            <ModalTitle>แจ้งเตือน</ModalTitle>
          </ModalHeader>
          {/* <ModalBody>เกิดข้อผิดพลาดในการลงทะเบียน {this.state.error}</ModalBody> */}
          <ModalBody>{this.state.error}</ModalBody>
          <ModalFooter>
            <button className="btn btn-danger" onClick={this.closeError}>
              OK
            </button>
          </ModalFooter>
        </Modal>
        <Modal
          show={this.state.successIsOpen}
          onHide={this.closeSuccess}
          size="s"
        >
          <ModalHeader>
            <ModalTitle>แจ้งเตือน</ModalTitle>
          </ModalHeader>
          <ModalBody>คุณได้ลงทะเบียนสำเร็จเรียบร้อยแล้ว</ModalBody>
          <ModalFooter>
            <button className="btn btn-success" onClick={this.closeSuccess}>
              OK
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
